import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import GuideMeButton from '../components/GuideMeButton';
import Intro from '../components/Intro';
import Card from '../components/VariantC/TallCard';
import AssessmentCard from '../components/AssessmentCard';
import getFormattedType from '../utils/getFormattedType';
import HeroContext from '../PageContext';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px 0',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      padding: 0,
    },
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  container: {
    [theme.breakpoints.up('1140')]: {
      width: 1140,
      padding: 0,
    },
    width: '100%',
    padding: '24px 5%',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& button': {
      fontSize: 18,
      lineHeight: '23px',
      fontFamily: 'MadaBold',
    },
    [theme.breakpoints.down('600')]: {
      flexDirection: 'column',
    },
  },
  textWrapper: {
    [theme.breakpoints.down('600')]: {
      marginBottom: 15,
    },
  },
  referralTextWrapper: {
    marginLeft: 36,
  },
  cardWrapper: {
    marginLeft: 100,
    '& > button': {
      width: 215,
      [theme.breakpoints.down('600')]: {
        width: '100%',
      },
      '& > div': {
        margin: 0,
        height: 285,
      },
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 24,
    },
    [theme.breakpoints.down('600')]: {
      width: '100%',
      marginLeft: 0,
    },
  },
}));

function VariantF({ shouldUseCarousel }) {
  const classes = useStyles();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const { featuredResources, sendMixpanelEvent } = useContext(HeroContext);
  const data = _get(featuredResources, [0, 0]);
  const type = getFormattedType(data);
  const clickHandler = (title, props) => {
    sendMixpanelEvent(title, props);
  };
  return (
    <div className={classes.root} data-test-id="hero-variant-f">
      <Box display="flex" className={classes.container}>
        <div
          className={_classNames({
            [classes.textWrapper]: true,
            [classes.referralTextWrapper]: !isXs && shouldUseCarousel,
          })}
        >
          <Intro isLandingPage={false} />
          <GuideMeButton noGuideMe isCentered={isXs && shouldUseCarousel} />
        </div>
        {!_isEmpty(data) && (
          <div className={classes.cardWrapper}>
            {type === 'assessment' ? (
              <AssessmentCard data={data} clickHandler={clickHandler} />
            ) : (
              <Card data={data} clickHandler={clickHandler} />
            )}
          </div>
        )}
      </Box>
    </div>
  );
}

VariantF.propTypes = {
  shouldUseCarousel: PropTypes.bool,
};

export default VariantF;
